module.exports = __webpack_public_path__ + "static/media/payment-method-american-exp.3ac51538.svg";